var baseForOwn = require('./_baseForOwn'),
    createBaseEach = require('./_createBaseEach');

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_baseEach.js
// module id = 46
// module chunks = 36434998819415 79611799117203 120690779865315 125193764933041 152099450743416